import { H1Span } from "@constellation-academy/epic-ui";
import React, { useContext } from "react";
import { useLazyLoadQuery } from "react-relay";
import { useTranslation } from "@i18n/hooks";
import { messageDefinitions_MessageDefinitionsQuery } from "@relay/messageDefinitions_MessageDefinitionsQuery.graphql";
import {
	MessageDefinitionsContext,
	MessageDefinitionsContextProvider,
} from "./message-definitions.context";
import { QUERY } from "./message-definitions.graphql";
import { headerClass } from "./message-definitions.styles";
import { MessageDefinitionsTable } from "./parts/message-definitions-table";
import { CreateMessageDefinitionButton } from "./parts/message-definitions-table/create-message-definition-button";
import { MessageDefinitionsTableFilters } from "./parts/message-definitions-table/message-definitions-table-filters";
import { BaseScreen } from "../../components/base-screen";

export const MessageDefinitionsScreen = () => {
	const { t } = useTranslation("common");
	const { filters } = useContext(MessageDefinitionsContext);

	const data = useLazyLoadQuery<messageDefinitions_MessageDefinitionsQuery>(
		QUERY,
		{
			filterByTextOpt: filters.filterByTextOpt,
		},
		{ fetchPolicy: "store-and-network" },
	);

	return (
		<MessageDefinitionsContextProvider>
			<BaseScreen>
				<div className={headerClass}>
					<H1Span>{t("messageDefinition.screenTitle")}</H1Span>
					<CreateMessageDefinitionButton />
				</div>
				<MessageDefinitionsTableFilters />
				<MessageDefinitionsTable messageDefinitionsFragmentRef={data} />
			</BaseScreen>
		</MessageDefinitionsContextProvider>
	);
};
